import { render } from "./GitMenu.vue?vue&type=template&id=0421ca30&scoped=true&ts=true"
import script from "./GitMenu.vue?vue&type=script&lang=ts"
export * from "./GitMenu.vue?vue&type=script&lang=ts"

import "./GitMenu.vue?vue&type=style&index=0&id=0421ca30&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0421ca30"]])

export default __exports__